// ==================================================
// Extrae un parametro de la current url
// ==================================================   
const getURLParameter = (n, url) => {
    const path = url || location.search;
    return decodeURIComponent((new RegExp('[?|&]' + n + '=' + '([^&;]+?)(&|#|;|$)').exec(path) || [null, ''])[1].replace(/\+/g, '%20')) || null;
};

const getURLPath = (n) => {
    const index = n || 0;
    var pathArray = window.location.pathname.split('/').filter(e => e);
    return pathArray[index];
};

const getURLQueryString = () => {
    return window.location.search.replace("?", "");
};

const testMatchURL = (url) => {
    let regexExp = new RegExp(document.location.host + "\/[a-zA-z]+(\/[A-Z]\/[0-9]\/[0-9])?");
    return regexExp.test(url);
};

module.exports = {
    getURLParameter,
    getURLPath,
    getURLQueryString,
    testMatchURL
};


// WEBPACK FOOTER //
// ./Statics/scripts/common/helpers/urlHelpers.js